
import template from './edit_service.html';

class AddEditServiceVM
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.service_types = ko.observableArray([]);
		this.service_name = ko.observable();
		this.service_type = ko.observable();
		this.type_settings = ko.observable();

		/*this.service_type.subscribe(async (type) => {
			if(!type)
				return;

			let settings = await this.get_type_settings();
			this.type_settings(settings);
		});*/
	}

	async get_type_settings()
	{
		let type = this.service_type();
		if(!type)
			return;
		
		let data = await Grape.fetches.getJSON('/api/record', 
			{ 
				schema: 'server',
				table: 'v_service_type_settings',
				filter: [
					{
						field: 'type_name',
						operand: '=',
						value: this.service_type()
					}
				]
			});
		
		if(data.records?.length > 0)
			return data.records.map(x => x.setting_name);

		return;
	}

	async btn_save_service()
	{
		if(!this.service_type() || !this.service_name())
		{
			Grape.alerts.alert({type: 'warning', title: 'Warning', message: 'Fill in all required fields Name and Type'});	
			return;
		}

		let result = await Grape.fetches.postJSON('/api/services', {
			service_name: this.service_name(),
			type_name: this.service_type()
		});

		this.dialog.close({status: 'OK', service_name: this.service_name(), type_name: this.service_type()});
	}

	btn_close ()
	{
		this.dialog.close({status: 'CLOSE'});
	}

}

class AddEditServiceDialog
{
	constructor(bindings, element)
	{
		this.bindings = bindings || {};
		this.viewModel = new AddEditServiceVM(this);		
	}

	init()
	{
		this.load();	
	}

	async load()
	{
		let types = await Grape.fetches.getJSON('/api/record', { 
			schema: 'server',
			table: 'service_type',
			fields: ['type_name']
		});

		if(types.records?.length > 0)
			this.viewModel.service_types(types.records);

	}
}

export default {
	name: 'AddEditService',
	dialog_class: AddEditServiceDialog,
	provider: 'ps',
	template: template
}
